export default __webpack_public_path__ + "static/media/2426.fc6c7078.png";